import { Chain } from 'viem'

export const injectiveTestnet: Chain = {
  id: 1439,
  name: 'Injective EVM Testnet',
  nativeCurrency: {
    decimals: 18,
    name: 'Injective',
    symbol: 'INJ',
  },
  rpcUrls: {
    default: {
      http: ['https://k8s.testnet.json-rpc.injective.network/'],
      webSocket: ['wss://k8s.testnet.ws.injective.network/'],
    },
    public: {
      http: ['https://k8s.testnet.json-rpc.injective.network/'],
      webSocket: ['wss://k8s.testnet.ws.injective.network/'],
    },
  },
  blockExplorers: {
    default: {
      name: 'BlockScout',
      url: 'https://testnet.blockscout.injective.network/blocks',
    },
  },
  testnet: true,
}
